import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-card-icon',
  templateUrl: './card-icon.component.html',
  styleUrls: ['./card-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardIconComponent {

  

  @Input() get type () {
    return this._cardTypeIcon;
  }
  set type(type: string) {
    this._cardTypeIcon = this.cardTypeMap[type] || this.cardTypeMap['generic'];
  }

  @Input() class: string = '';


  private cardTypeMap: { [key: string]: string } = {
    visa: '/assets/media/svg/cards/visa.svg',
    mastercard: '/assets/media/svg/cards/mastercard.svg',
    'american-express': '/assets/media/svg/cards/amex.svg',
    discover: '/assets/media/svg/cards/discover.svg',
    jcb: '/assets/media/svg/cards/jcb.svg',
    unionpay: '/assets/media/svg/cards/unionpay.svg',
    maestro: '/assets/media/svg/cards/maestro.svg',
    mir: '/assets/media/svg/cards/mir.svg',
    'diners-club': '/assets/media/svg/cards/diners.svg',
    generic: '/assets/media/svg/cards/generic.svg',
  };

  _cardTypeIcon: string = this.cardTypeMap['generic'];
}